<app-navbar [title]="contractor()?.fullName" [showReservationSearch]="false"> </app-navbar>

@if (isLoading()) {
	<div class="spinner-container">
		<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
	</div>
}

<div class="container-fluid">
	<mat-tab-group animationDuration="0ms">
		<mat-tab label="Informacje o kontrahencie">
			<app-contractor-info
				[contractor]="contractor()"
				(phoneLoader)="patchContractor({ phoneLoader: $event })"
				(updatedPhone)="patchContractor({ phone: $event })"
				(mailsLoader)="patchContractor({ mailLoader: $event })"
				(updatedMails)="patchContractor({ mails: $event })"
			></app-contractor-info>
		</mat-tab>

		<mat-tab label="Szablony">
			<app-contractor-templates
				[contractorId]="contractor()?.id ?? 0"
				[templates]="templates()"
				[contractorTemplates]="contractorTemplates()"
			>
			</app-contractor-templates>
		</mat-tab>
	</mat-tab-group>
</div>
